export default __webpack_public_path__ + "static/aish-c3f6f8a73db6b7fe3890ae02cba070e4.jpg";